import { createClient, HttpError } from "@/http/lib";
import { systemErrorResponseHandler } from "../handlers/responseError";
import { apiBaseUrl } from "../config";

export const map = createClient({
  baseURL: apiBaseUrl,
});

map.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(new HttpError(error))
);

map.interceptors.response.use(
  (response) => response,
  (error) => {
    systemErrorResponseHandler(error, map.getVueInstance());
    return Promise.reject(new HttpError(error));
  }
);
